export default function ChatHeader() {
  return (
    <div className="chat-header">
      <div className="header-left">
        <h3>Ask Agent</h3>
      </div>

      <div className="header-right">

      </div>
    </div>
  );
}
